import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { putRSSLink } from '../../../api/channels';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateLinkCIDKey } from '../../../components/Items/utils/generateLinkCIDKey';

import { REQUEST } from '../../../constants/request';

export const updateRSSLink = createAsyncThunk(
  'channels/updateRSSLink',
  async (rssData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await putRSSLink(rssData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return !(
        state.items.rssLinks.actions.update.request[generateLinkCIDKey(path)]
          ?.loading === REQUEST.pending
      );
    },
  },
);

export const updateRSSLinkExtraReducers = builder => {
  builder
    .addCase(updateRSSLink.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.rssLinks.actions.update.request,
        action,
        generateLinkCIDKey(action.meta.arg.path),
      );
    })
    .addCase(updateRSSLink.fulfilled, (state, action) => {
      const linkCIDKey = generateLinkCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.rssLinks.actions.update.request[linkCIDKey],
        action,
        () => {
          state.rssLinks.byId[linkCIDKey] = {
            ...action.payload,
            linkId: action.payload.id,
            id: linkCIDKey,
          };
        },
      );
    })
    .addCase(updateRSSLink.rejected, (state, action) => {
      handleRequestRejection(
        state.rssLinks.actions.update.request[
          generateLinkCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
